import { createSelector } from '@ngrx/store';
import { i18nFeature, I18nState } from '../i18n/i18n.reducers';
import { RoleLabelType } from '../types';

const toRoleArray = (constantsTranslations: I18nState['constants']) =>
  Object.keys(RoleLabelType).map((rl) => ({
    id: rl,
    label: constantsTranslations[rl],
  }));

// Custom selector for role labels
export const selectRolesAsDropdownItems = createSelector(i18nFeature.selectConstants, (constants) =>
  toRoleArray(constants),
);
